import React, { useEffect, useState } from "react";
import { loadImage } from "../../api/medecin";
import { IPatient } from "../../types/patient";
import Spinner from "../Spinner";
import { useAtom } from "jotai";
import { refreshAtomRequest } from "../../state/refreshRequestList";

interface IProps {
  helperCategorie: Function;
  setAddCategorieDocMenu: Function;
  addCategorieDocMenu: boolean;

  documentsList: [] | any;
  patientData: IPatient | any;
  setImageUrl: Function;
  setModalImage: Function;
  retriveDemandeMyAPI: Function;
  setDocumentsList: Function;
}

const parseImage = (specialite, userId, filePath) => ({
  original: loadImage(specialite, userId, "thumbnail", filePath),
});

const ImagesContainer: React.FC<IProps> = ({
  documentsList,
  patientData,
  setImageUrl,
  setModalImage,
  setDocumentsList,
}) => {
  const [parsedImages, setParsedImages] = useState<any[]>([]);
  const [refresh] = useAtom(refreshAtomRequest);
  const [loading, setLoading] = useState(false);

  const formatBodyPart = (value: string | null | undefined) => {
    if (!value || typeof value !== "string") return ""
    return value.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/\b\w/g, (char) => char.toUpperCase())
  }

  useEffect(() => {
    if (!documentsList?.length) return;

    Promise.all(
      documentsList.map(async (img) => ({
        original: await loadImage(
          img.specialite,
          img.patientId,
          "thumbnail",
          img.filePath
        ),
      }))
    ).then(setParsedImages);
  }, [documentsList, refresh?.state]);

  return loading ? (
    <Spinner />
  ) : (
    <>
      <div className="flex">
        <p className="doc-title">Images</p>
      </div>
      <div className="images flex flex-wrap min-w-full mt-2 gap-7">
        <div className="images flex flex-wrap min-w-full mt-2 gap-7">
          {parsedImages.length !== 0 ||
          patientData.status !== "WAIT_FOR_IMGS" ? (
            parsedImages.map((i: any, k: number) => {
              return (
                i && (
                  <div className="flex flex-col sm:flex-row items-center border rounded-lg bg-white overflow-hidden">
                    {/* Image */}
                    <div className="w-full sm:w-40 md:w-48 flex-shrink-0 flex justify-center items-center p-3 sm:p-0">
                      <img
                        src={i?.original}
                        className="w-40 h-40 sm:w-full sm:h-full object-cover rounded-md cursor-pointer"
                        alt="document katomi"
                        onLoad={() => setLoading(false)}
                        onClick={() => {
                          setImageUrl({
                            url: i?.original,
                            type: i?.original,
                            fileInfo: documentsList[k],
                          });

                          setModalImage(true);
                        }}
                      />
                    </div>

                      {/* Details */}
                      <div className="flex-1 p-4 sm:p-5 text-left w-full">
                        <h3 className="text-base font-semibold text-gray-800 mb-4">
                          Informations
                        </h3>

                        <div className="space-y-3 text-sm">
                          <div className="flex flex-col sm:flex-row">
                            <span className="sm:w-36 text-gray-500 font-medium">
                              Ancienneté
                            </span>
                            <span className="flex-1 text-gray-800">
                              {formatBodyPart(documentsList[k]?.anciennete) || "Non spécifié"}
                            </span>
                          </div>

                          <div className="flex flex-col sm:flex-row">
                            <span className="sm:w-36 text-gray-500 font-medium">
                              Taille
                            </span>
                            <span className="flex-1 text-gray-800">
                              {documentsList[k]?.taille
                                ? `${documentsList[k].taille} mm`
                                : "Non spécifié"}
                            </span>
                          </div>

                          <div className="flex flex-col sm:flex-row">
                            <span className="sm:w-36 text-gray-500 font-medium">
                              Douleur
                            </span>
                            <span className="flex-1 text-gray-800">
                              {formatBodyPart(documentsList[k]?.douleur) || "Non spécifié"}
                            </span>
                          </div>

                          <div className="flex flex-col sm:flex-row">
                            <span className="sm:w-36 text-gray-500 font-medium">
                              Position
                            </span>
                            <span className="flex-1 text-gray-800">
                              {formatBodyPart(documentsList[k]?.bodyPart) || "Non spécifié"}
                            </span>
                          </div>

                          <div className="border-t pt-3 mt-3">
                            <p className="font-medium text-gray-500 mb-2">Message</p>
                            <p className="text-gray-800 whitespace-pre-wrap break-words">
                              {documentsList[k]?.message || "Pas de notes."}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                )
              );
            })
          ) : (
            <div className="flexCenter w-full anEmptyBox">
              <p className="card-subtitle">
                N'oublier pas de joindre les photos de votre patient afin de
                bénéficier de l'avis médical de nos experts en{" "}
                {patientData.specialite} .
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ImagesContainer;
